module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1029-82010c014f5f50898ab3fc2eb5ed0616.png";